/**
 * Utilitaires d'authentification backend
 * Tous les mots de passe sont validés côté serveur.
 * Le token n'est PAS persisté — une nouvelle connexion est requise à chaque session.
 */

const API_URL = '/api';
let currentToken = null;

export async function loginUser(username, password) {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    const data = await response.json();
    if (data.success && data.token) {
      currentToken = data.token;
    }
    return data;
  } catch (error) {
    return { success: false, message: 'Erreur réseau' };
  }
}

export async function verifyToken() {
  if (!currentToken) return { success: false };

  try {
    const response = await fetch(`${API_URL}/auth/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: currentToken })
    });
    return await response.json();
  } catch (error) {
    return { success: false, message: 'Erreur réseau' };
  }
}

export function logoutUser() {
  currentToken = null;
}

export function getToken() {
  return currentToken;
}

export async function changeAdminPassword(currentPassword, newPassword) {
  if (!currentToken) {
    return { success: false, message: 'Non authentifié' };
  }

  try {
    const response = await fetch(`${API_URL}/admin/change-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken}`
      },
      body: JSON.stringify({ currentPassword, newPassword })
    });
    return await response.json();
  } catch (error) {
    return { success: false, message: 'Erreur réseau' };
  }
}
